import { NgModule } from '@angular/core';
import { I18nConfig, I18nModule, provideConfig } from "@spartacus/core";
import { productImageZoomTranslationChunksConfig, productImageZoomTranslationsEn } from "@spartacus/product/image-zoom/assets";
import { ProductImageZoomRootModule } from "@spartacus/product/image-zoom/root";
import { GenProductImageZoomProductImagesComponent } from './product-image-zoom-product-images/product-image-zoom-product-images.component';
import { CarouselModule, IconModule, KeyboardFocusModule, MediaModule, OutletModule } from '@spartacus/storefront';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { ProductImageZoomModule } from '@spartacus/product/image-zoom/components';
import { GenProductImageZoomTriggerComponent } from './product-image-zoom-product-images/product-image-zoom-trigger/product-image-zoom-trigger.component'

@NgModule({
  declarations: [
    GenProductImageZoomProductImagesComponent,
  ],
  imports: [
    ProductImageZoomRootModule,
    CarouselModule,
    CommonModule,
    I18nModule,
    IconModule,
    KeyboardFocusModule,
    MediaModule,
    OutletModule,
    RouterModule,
    ProductImageZoomModule,
    GenProductImageZoomTriggerComponent,
  ],
  providers: [
  provideConfig(<I18nConfig>{
    i18n: {
      resources: { en: productImageZoomTranslationsEn },
      chunks: productImageZoomTranslationChunksConfig,
    },
  })
  ],
  exports: [
    GenProductImageZoomProductImagesComponent,
  ],
})
export class GenProductImageZoomFeatureModule { }
